import React from 'react'
import renderMathInElement from 'katex_auto'
export default class Tex extends React.Component {
    render() {
        //https://developer.mozilla.org/en-US/docs/Web/API/Document/createElement
        var newSpan=document.createElement('span');
        newSpan.innerHTML=this.props.bind;
        //var newText=document.createTextNode(this.props.bind);
        //newSpan.appendChild(newText);
        renderMathInElement(newSpan); //Check window.  ??
        var html=function(){
            return {__html: newSpan.innerHTML};
        };
        return (
            <span dangerouslySetInnerHTML={html()}/>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Tex.js